import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Collapse, IconButton, Stack } from '@mui/material';
import { FC, PropsWithChildren, useEffect, useState } from 'react';
import styles from './CollapsibleSection.module.css';

interface CollapsibleSectionProps {
  heading: string;
  expandAll?: boolean;
  defaultExpanded?: boolean;
  setExpandAll?: (value: boolean) => void;
}

const CollapsibleSection: FC<PropsWithChildren<CollapsibleSectionProps>> = ({ heading, expandAll, children, defaultExpanded = false, setExpandAll }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => { if (expandAll) setOpen(expandAll) }, [expandAll, setOpen]);

  useEffect(() => { if (!open && setExpandAll) setExpandAll(open) }, [open, setExpandAll])

  return (
    <div className={styles.CollapsibleSection}>
      <div className={open ? [styles.CollapsibleHeader, styles.Expanded].join(' ') : styles.CollapsibleHeader} onClick={() => setOpen(!open)}>
        <span className={styles.HeaderText}>{heading}</span>
        <IconButton className={styles.Arrow} aria-label="expand" size="small" onClick={() => setOpen(!open)}>
          {open ? (<KeyboardArrowDown />) : (<KeyboardArrowUp />)}
        </IconButton>
      </div>
      <Collapse className={styles.Container} in={open}>
        <Stack direction="column" spacing={2} padding="32px 20px" alignItems="center" width="100%">
            {children}
        </Stack>
      </Collapse>
    </div>
  )
};

export default CollapsibleSection;
